export default __webpack_public_path__ + "static/media/lyrical_linguist_intro.067cc76a.mp3";